import { CommandResult, ExternalLink } from '../amorg-common';
import { apiPath } from "./adminClientApi";
import { commandAuthWrapper, queryAuthWrapper } from './serverApiHelpers';

export const getExternalLinks = async (): Promise<ExternalLink[]> =>
{
    const data = await queryAuthWrapper(`${apiPath}/externallinks`) as ExternalLink[];
    return data;
};

export const createExternalLink = async (link: ExternalLink): Promise<CommandResult> =>
{
    return commandAuthWrapper(`${apiPath}/externallinks`, 'POST',
        { ...link }
    );
}

export const updateExternalLink = async (link: ExternalLink): Promise<CommandResult> =>
{
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const {id, ...linkWithoutId} = link;
    return commandAuthWrapper(`${apiPath}/externallinks/${link.id}`, 'PUT',
        { ...linkWithoutId }
    );
}

export const deleteExternalLink = async (linkId: string): Promise<CommandResult> =>
{
    return commandAuthWrapper(`${apiPath}/externallinks/${linkId}`, 'DELETE');
}   